// extracted by mini-css-extract-plugin
export var altDescription = "style-module--alt-description--6625e";
export var caption = "style-module--caption--e42dc";
export var figure = "style-module--figure--67199";
export var image = "style-module--image--3c4e6";
export var imageVariation = "style-module--image-variation--54c7e";
export var title = "style-module--title--b88fb";